<template>
    <div id="videoplayer" class="videoplayer-wrapper" @click="onVideoClick">
        <img v-if="paused" style="position: absolute; align-self: center; width: 4em;" src="./images/play.png">
    </div>
</template>

<script>
    let player = document.createElement('video');
    player.autoplay = true;
    player.playsInline = true;

    let authoriseVideoElement = () => {
        player.play();
        player.pause();
        
        document.removeEventListener('touchstart', authoriseVideoElement);
    };

    document.addEventListener('touchstart', authoriseVideoElement);

    export default {
        'props': {
            data: {}
        },
        data(){
            return {
                player: '',
                url: this.data[0].question.video,
                paused: false,
            };
        },
        watch: {
            data: {
                handler(newVal, oldVal) {
                    if (newVal[0].question.id != oldVal[0].question.id) {                        
                        player.pause();
                        player.src = newVal[0].question.video;
                        player.load();
                        player.play();
                    }
                }
            }
        },
        computed: {
            isVideoPaused() {
                if (player.paused) {                    
                    return player.paused;
                }
                
                return false;
            }
        },
        methods: {
            onVideoEnd() {
                this.$emit('next');
            },
            onVideoClick() {
                if (player.paused) {
                    player.play();
                    this.paused = false;
                } else {
                    player.pause();
                    this.paused = true;
                }
            },
            onCanPlay() {
                this.paused = player.paused;
            }
        },
        mounted(){            
            document.getElementById('videoplayer').appendChild(player);
            player.src = this.url;
            player.load();
            player.play();            
            player.oncanplay = this.onCanPlay;
            player.onended = this.onVideoEnd;
        },
        beforeDestroy() { 
            player.pause();
        }
    }
</script>